import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import apinode from '../../services/apinode'

function AtualizarEstoqueModal({ show, handleClose, SkuAtualizar }) {
  const [novoEstoque, setNovoEstoque] = useState('')
  const [tipoOperacao, setTipoOperacao] = useState('entrada') // Padrão para 'entrada'
  // const [selectedSku, setSelectedSku] = useState(SkuAtualizar) // Use o valor inicial se fornecido

  const handleUpdate = async () => {
    try {
      const response = await apinode.put(
        `/estoque/ajustemanual/${localStorage.idconta}`,
        {
          quantidade: novoEstoque,
          tipo: tipoOperacao,
          sku: SkuAtualizar,
        },
      )

      if (response.status === 200) {
        console.log('Status alterado com sucesso!')
        toast.success('Status alterado com sucesso!')
      } else {
        console.error('Erro ao alterar status. Resposta:', response)
      }
    } catch (error) {
      console.error('Erro ao buscar contas:', error)
      toast.error('Erro ao alterar status. Resposta:', error)
    }
  }

  const handleConfirmUpdate = () => {
    handleUpdate()

    // Limpe o estado e feche o modal
    setNovoEstoque('')
    setTipoOperacao('entrada') // Padrão para 'entrada'
    handleClose()
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Atualizar Estoque</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formNovoEstoque">
            <Form.Label>Novo Estoque</Form.Label>
            <Form.Control
              type="number"
              placeholder="Digite o novo valor de estoque"
              value={novoEstoque}
              onChange={(e) => setNovoEstoque(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId="formTipoOperacao">
            <Form.Label>Tipo de Operação</Form.Label>
            <Form.Control
              as="select"
              value={tipoOperacao}
              onChange={(e) => setTipoOperacao(e.target.value)}
            >
              <option value="entrada">Entrada</option>
              <option value="saida">Saída</option>
              <option value="ajuste">Ajuste (Inventário)</option>
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
        >
          Fechar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirmUpdate}
        >
          Atualizar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AtualizarEstoqueModal
